import { keys } from '@classic/Foundation/Analytics/AnalyticsDataLayer'
import { trackEvent } from '@classic/Foundation/Analytics/GoogleTagManagerService'
import { get } from '@classic/Foundation/Services/ApiService'
import type { SearchResult } from '@core/Areas/Search/types'

export const getRacingSearchResults = (searchTerm: string) => {
  trackEvent(keys.searchQuery, { searchQueryText: searchTerm })
  return get<{ results: SearchResult[] }>({
    url: `/api/search/query?q=${searchTerm}&includeUnmatched`,
  })
}
